export default "__VITE_ASSET__UZw_yLzF__"